var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("q-card", { staticClass: "auth-card" }, [
    _c("div", { staticClass: "auth-title" }, [
      _vm._v("\n    Вход в личный кабинет\n  ")
    ]),
    _vm._v(" "),
    _c(
      "form",
      {
        staticClass: "auth-form",
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.auth($event)
          }
        }
      },
      [
        _c("q-input", {
          staticClass: "auth-input",
          attrs: {
            outlined: "",
            type: "text",
            label: "Логин",
            error: _vm.errorLogin
          },
          on: { focus: _vm.onFocus },
          model: {
            value: _vm.login,
            callback: function($$v) {
              _vm.login = $$v
            },
            expression: "login"
          }
        }),
        _vm._v(" "),
        _c("q-input", {
          staticClass: "auth-input",
          attrs: {
            outlined: "",
            type: _vm.isPwd ? "password" : "text",
            label: "Пароль",
            autocomplete: "on",
            error: _vm.errorPass
          },
          on: { focus: _vm.onFocus },
          scopedSlots: _vm._u([
            {
              key: "append",
              fn: function() {
                return [
                  _c("q-icon", {
                    staticClass: "cursor-pointer",
                    attrs: {
                      name: _vm.isPwd ? "visibility_off" : "visibility",
                      autocomplete: "on"
                    },
                    on: {
                      click: function($event) {
                        _vm.isPwd = !_vm.isPwd
                      }
                    }
                  })
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.password,
            callback: function($$v) {
              _vm.password = $$v
            },
            expression: "password"
          }
        }),
        _vm._v(" "),
        _c("q-btn", {
          staticClass: "auth-btn",
          attrs: {
            unelevated: "",
            color: "primary",
            label: "Войти",
            type: "submit"
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }